import * as React from 'react';

import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { Redirect, RouteComponentProps } from 'react-router';

import { getUnverifiedEmail, updateEmail } from 'actions/account';
import { Button } from 'components/Button';
import { LayoutHeader } from 'components/Layout';
import { ROUTE_ACCOUNT_EMAIL_UPDATE } from 'constants/app';
import { Account, AccountEmailUpdateForm } from 'models/account';
import { AppState } from 'models/app';

import './AccountEmailUnverified.scss';

interface StateProps {
  account: Account;
  isRenderValid: boolean;
}

interface DispatchProps {
  getUnverifiedEmail: typeof getUnverifiedEmail;
  updateEmail: typeof updateEmail;
}

type OwnProps = RouteComponentProps<{}>;
type AccountEmailUnverifiedProps = StateProps & DispatchProps & OwnProps;

class AccountEmailUnverifiedContainer extends React.Component<AccountEmailUnverifiedProps, {}> {
  constructor(props: AccountEmailUnverifiedProps) {
    super(props);

    this.redirectTo = this.redirectTo.bind(this);
    this.resendVerificationEmail = this.resendVerificationEmail.bind(this);
  }

  componentWillMount() {
    this.props.getUnverifiedEmail();
  }

  render() {
    const { account, history, isRenderValid } = this.props;

    if (!isRenderValid) {
      return <Redirect to="/"/>;
    }

    return (
      <div className="account-email-unverified__container o-container o-container--fluid o-container--fluid-vertical">
        <LayoutHeader actionIcon="ic-close" actionHandler={history.goBack}>
          <h1 className="o-layout-header-title">
            <FormattedMessage id="account.email.unverified.title"/>
          </h1>
        </LayoutHeader>

        <div className="account-email-unverified__message">
          <FormattedMessage id="account.email.unverified.message" />
        </div>
        <div className="account-email-unverified__email">
          {account.unverifiedEmail}
        </div>
        <Button type="button" className="button--outline-blue button--full" onClick={this.redirectTo(ROUTE_ACCOUNT_EMAIL_UPDATE)}>
          <FormattedMessage id="account.email.unverified.update.email.button" />
        </Button>
        <Button type="button" className="account-email-unverified__resend-verification-button button--primary button--full" onClick={this.resendVerificationEmail()}>
          <FormattedMessage id="account.email.unverified.resend.verification.button" />
        </Button>
      </div>
    );
  }

  private redirectTo(redirectPath: string) {
    return () => {
      const { history } = this.props;
      history.push(redirectPath);
    };
  }

  private resendVerificationEmail() {
    return () => {
      const { unverifiedEmail } = this.props.account;
      if (unverifiedEmail) {
        const form: AccountEmailUpdateForm = {
          email: unverifiedEmail
        };

        this.props.updateEmail(form);
      }
    };
  }
}

export const AccountEmailUnverified = connect<StateProps, {}, OwnProps>(
  (state: AppState) => ({
    account: state.accountState.account,
    isRenderValid: !!state.accountState.account.unverifiedEmail && !state.accountState.account.email
  }), { getUnverifiedEmail, updateEmail }
)(AccountEmailUnverifiedContainer);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Account/Email/AccountEmailUnverified/AccountEmailUnverified.tsx